import s from "./style.module.css";
import React, {useEffect, useState} from "react";
import {Checkbox, CircularProgress, MenuItem, Select} from "@mui/material";
import api from "../../api/api";
import openEye from "../../assets/eye-open-svgrepo-com.svg"
import closeEye from "../../assets/eye-close-svgrepo-com.svg"
import {toast} from "react-toastify";

const AgeGroupAddition = () => {

    const [ageGroups, setAgeGroups] = useState([]);
    const [select, setSelect] = useState(null);
    const [checkbox, setCheckbox] = useState(false);

    const [mainName, setMainName] = useState("");
    const [shortName, setShortName] = useState("");
    const [menName, setMenName] = useState("");
    const [femaleName, setFemaleName] = useState("");
    const [crmId, setCrmId] = useState('');
    const [displayedValue, setDisplayedValue] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [visualRemoveAgeGroup, setVisualRemoveAgeGroup] = useState(false);
    const [visualAddAgeGroup, setVisualAddAgeGroup] = useState(false);

    const getAgeGroups = async () => {
        const res = await api().get("/judge/age-groups");
        if (res?.data.status === 'ok') {
            setAgeGroups(res?.data.age_group);
        }
    }

    useEffect(() => {
        getAgeGroups().then(() => {
        });
    }, []);

    const handleKeyDown = (e) => {
        const {key, keyCode} = e;

        if (keyCode >= 9 && keyCode <= 45 || keyCode >= 112 && keyCode <= 123) {
            return;
        }

        if (key === 'Backspace') {
            setDisplayedValue((prev) => prev.slice(0, -1));
        } else if (key.length === 1) {
            setDisplayedValue((prev) => prev + key);
        }
    };

    const deleteAgeGroupHandler = async () => {
        setVisualRemoveAgeGroup(true);
        if (select === null) {
            toast.error("Выберите возрастную группу для удаления!")
        } else if (displayedValue === '') {
            toast.error("Введите пароль!")
        } else {
            const res = await api().delete(`/competition/delete-age-group/${select}`, {
                data: {
                    password: displayedValue
                }
            });

            if (res?.data?.status === 'ok') {
                setShowPassword(false);
                setSelect(null);
                setDisplayedValue('');
                getAgeGroups().then(() => {
                });
                toast.success("Возрастная группа успешна удалена!")
            } else {
                toast.error(res?.data?.msg)
            }
        }
        setVisualRemoveAgeGroup(false);
    }

    const addAgeGroupHandler = async () => {
        setVisualAddAgeGroup(true);
        if (select === null) {
            toast.error("Выберите шаблон возрастной группы!");
        } else if (mainName === '') {
            toast.error("Введите название возрастной группы!");
        } else if (shortName === '') {
            toast.error("Введите короткое название возрастной группы!");
        } else if (menName === '') {
            toast.error("Введите название для мужского пола!");
        } else if (femaleName === '') {
            toast.error("Введите название для женского пола!");
        } else if (crmId === '') {
            toast.error("Введите ID возрастной группы в ЛК!");
        } else {
            const res = await api().post(`/competition/create-age-group`, {
                age_group_id: select,
                age_group_name: mainName,
                short_name: shortName,
                men_name: menName,
                female_name: femaleName,
                crm_id: crmId,
                is_discipline_create: checkbox
            });

            if (res?.data?.status === 'ok') {
                setSelect(null);
                setMainName('');
                setMenName('');
                setShortName('');
                setFemaleName('');
                setCrmId('');
                getAgeGroups().then(() => {
                });
                toast.success("Возрастная группа успешна создана!")
            } else {
                toast.error(res?.data?.msg)
            }
        }
        setVisualAddAgeGroup(false);
    }

    return (
        <div className={s.content} style={{borderLeft: '1px solid rgb(221, 221, 221)'}}>
            <div style={{display: "flex", flexDirection: 'column', alignItems: 'center'}}>
                <h1 style={{marginBottom: "20px"}}>Добавление возрастной группы</h1>
                <Select
                    placeholder={'Шаблон возрастной группы'}
                    displayEmpty
                    value={select}
                    onChange={(e) => {
                        setSelect(e.target.value)
                    }}
                    inputProps={{'aria-label': 'Without label'}}
                    sx={{
                        height: '33px',
                        width: '280px',
                        backgroundColor: '#fff'
                    }}
                    labelId="demo-simple-select-label">

                    <MenuItem sx={{
                        display: 'none'
                    }} hidden disabled selected value={null}>Шаблон возрастной группы</MenuItem>
                    {ageGroups.map((el) => <MenuItem key={el.age_group_id}
                                                     value={el.age_group_id}>{`${el.age_group_name}`}</MenuItem>)}

                </Select>

                <input className={s.input} type="text" placeholder={"Название возрастной группы"} value={mainName}
                       style={{width: '250px', marginTop: '19px'}}
                       onChange={(e) => setMainName(e.target.value)}/>
                <input className={s.input} type="text" placeholder={"Короткое название"} value={shortName}
                       style={{width: '250px'}}
                       onChange={(e) => setShortName(e.target.value)}/>
                <input className={s.input} type="text" placeholder={"Название для мужского пола"}
                       value={menName} style={{width: '250px'}}
                       onChange={(e) => setMenName(e.target.value)}/>
                <input className={s.input} type="text" placeholder={"Название для женского пола"}
                       value={femaleName} style={{width: '250px'}}
                       onChange={(e) => setFemaleName(e.target.value)}/>
                <input className={s.input} type="number" placeholder={"ID возрастной группы в ЛК"}
                       value={crmId} style={{width: '250px'}}
                       onChange={(e) => setCrmId(e.target.value)}/>

                <div style={{display: "flex", justifyContent: 'center', alignItems: 'center', width: '300px', fontSize: '14px', marginBottom: '10px'}}>
                    <Checkbox onChange={(e) => {setCheckbox(e.target.checked)}}/><span>Создать дисциплину для теста</span>
                </div>

                <div style={{marginTop: '0'}} className={s.button} onClick={addAgeGroupHandler}>Добавить
                    {visualAddAgeGroup &&
                        <CircularProgress style={{position: "absolute", marginLeft: "179px", marginTop: "13px"}}
                                          size="12px" color="inherit"/>}
                </div>
                <span style={{fontSize: '12px', marginTop: '20px'}}>Удалить выбранный шаблон возрастной группы?</span>
                <div style={{display: "flex", justifyContent: 'space-between', width: '250px'}}>
                    <div style={{width: '120px', position: 'relative'}}>
                        <input
                            className={s.input}
                            type="text"
                            placeholder="Пароль"
                            value={showPassword ? displayedValue : '*'.repeat(displayedValue.length || 0)}
                            style={{width: '100%', paddingRight: '30px'}}
                            onKeyDown={handleKeyDown}
                            onChange={() => {
                            }}
                        />
                        <span
                            style={{
                                position: 'absolute',
                                right: '5px',
                                top: '38%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                            }}
                            onClick={() => setShowPassword(!showPassword)}
                            aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                        >
                            <img
                                src={showPassword ? openEye : closeEye}
                                alt={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                                width="18"
                                height="18"
                            />
                        </span>
                    </div>
                    <div style={{width: '110px', marginTop: '0', background: 'red'}} className={s.buttonDel}
                         onClick={deleteAgeGroupHandler}>Удалить
                        {visualRemoveAgeGroup &&
                            <CircularProgress style={{position: "absolute", marginLeft: "89px", marginTop: "13px"}}
                                              size="12px" color="inherit"/>}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default AgeGroupAddition;